import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteProject(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/projects/${id}`,
        method: "DELETE",
    });
}
